export default __webpack_public_path__ + "static/singapore-5f09b962d1338eacfc0ea02f91a1dd3f.svg";